module.exports = __webpack_public_path__ + "static/media/development-energizacao (2).486cdd19.png";